// @ts-ignore
globalThis.CONFIG = {
  apiBaseUrl: process.env.NEXT_PUBLIC_API_BASE_URL,
  // @ts-ignore
  ...globalThis.CONFIG,
};
